import { CURRENT_VERSION } from '../../../config/environment';
import { SupportedNetworks } from '../../../config/networkAddresses';
/**
 * Checks if a network is supported based on the provided chainId.
 * @param {IIsNetworkSupported} options - The options object.
 * @param {number} options.chainId - The chainId of the network to check.
 * @returns {boolean} - Returns true if the network is supported, false otherwise.
 */
export function isNetworkSupported(_a) {
    var chainId = _a.chainId;
    return SupportedNetworks(CURRENT_VERSION)[chainId] !== undefined;
}
